import * as React from 'react';
import styled from 'styled-components';
import { ICollapsibleItemProps } from '../collapsible-types';
import { Icon } from '../../icon';
import { selectThemeSemantics } from '../../../styling';
import { Typography } from '../../typography';
import { FlexBox } from '../../flex-box';

export const HeaderWrapper = styled(FlexBox).attrs(() => ({
    className: String('ap-collapsible-itemHeaderWrapper')
}))`
    position: relative;
    padding: ${selectThemeSemantics(({ gap }) => `${gap.l} ${gap.xxl}`)};
    cursor: pointer;
    outline-color: ${({ theme: { semantics: { palette } } }) => palette.themePrimary};
    border-top-width:  ${({ theme: { collapsible: { composites: { itemHeader } } } }) => itemHeader.borderWidth};
    border-top-style: none;
    border-top-color: ${({ theme: { collapsible: { colors: { itemHeader } } } }) => itemHeader.borderColor};
`;

export const CollapsibleItemHeader = styled(Typography.Medium).attrs(() => ({
    className: String('ap-collapsible-itemHeader')
})) <{ $arrowPosition: 'start' | 'end' }>`
    user-select: none;
    position: relative;
    padding-left: ${({ $arrowPosition, theme: { semantics: { gap } } }) => ($arrowPosition === 'start' && gap.l)};
    background-color: ${({ theme: { collapsible: { colors: { itemHeader } } } }) => itemHeader.backgroundColor};
    color: ${({ theme: { collapsible: { colors: { itemHeader } } } }) => itemHeader.foregroundColor};
`;

function ArrowIcon({ className }: Pick<ICollapsibleItemProps, 'className'>) {
    return (
        <Icon className={className} iconName="ap-right-arrow-thin2.outline" iconSize="16" />
    );
}

export const CollapsibleItemArrow = styled(ArrowIcon).attrs(() => ({
    className: String('ap-collapsible-itemArrow')
})) <Pick<ICollapsibleItemProps, 'isExpanded'>>`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)')};
    transition: all 0.3s;
    transform-origin: 50% 50%;
    fill: ${({ theme: { collapsible: { colors } } }) => colors.iconColor};
`;
